import React from "react";
import { format } from "date-fns";

// eslint-disable-next-line react/no-danger
const createMarkup = html => <div dangerouslySetInnerHTML={{ __html: html }} />;

export const COLUMNS = [
  {
    Header: "Location ID",
    accessor: "LocationID",
    id: "LocationId"
  },
  {
    Header: "Location Name",
    accessor: "LocationName"
  },
  {
    Header: "Active",
    accessor: "Active"
  },
  { Header: "Bill To #", accessor: "Customer.CustomerNo", id: "CustomerNo" },
  {
    Header: "Bill To Name",
    accessor: "Customer.Name",
    id: "Customer"
  },
  {
    Header: "Address 1",
    accessor: "Address1"
  },
  {
    Header: "Address 2",
    accessor: "Address2"
  },
  {
    Header: "City",
    accessor: "City"
  },
  {
    Header: "State",
    accessor: "State"
  },
  {
    Header: "Zip",
    accessor: "Zip"
  },
  {
    Header: "Pickup Loc.",
    accessor: "PickupLocation",
    id: "PickupLocation"
  },
  {
    Header: "Delivery Loc.",
    accessor: "DeliveryLocation",
    id: "DeliveryLocation"
  },
  {
    Header: "Country",
    accessor: "Country"
  },
  {
    Header: "Time Zone",
    id: "TimeZone",
    accessor: "TimeZone.CodeDescription"
  },
  {
    Header: "Location Type",
    accessor: "LocationType.CodeDescription",
    id: "LocationType"
  },
  {
    Header: "Number Of Loading Bays",
    accessor: "NumberOfLoadingBays"
  },
  {
    Header: "Number Of Unloading Bays",
    accessor: "NumberOfUnLoadingBays"
  },
  {
    Header: "Scales",
    accessor: "Scales"
  },
  {
    Header: "Last Used Date",
    accessor: "LastUsedDate",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "XATA Data Station",
    accessor: "XATADataStation"
  },
  {
    Header: "Special External Instructions",
    accessor: "SpecialExternalInstructions",
    Cell: ({ cell }) => (cell.value !== null ? createMarkup(cell.value) : null)
  },
  {
    Header: "Internal Notes",
    accessor: "InternalNotes",
    Cell: ({ cell }) => (cell.value !== null ? createMarkup(cell.value) : null)
  }
];
